import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'obj2string' } )
export class Obj2StringPipe implements PipeTransform {
    transform ( value ) {
        return `${ value.name || '' } ${ value.firstName || '' } ${ value.lastName || '' }`;
    }
}

